export default __webpack_public_path__ + "static/media/IconDownload.1e894060.svg";